









































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { refsService } from '@/app/shared/refs.service';
import { CampaignModel } from '@/app/shared/models';
import DialogCampaignDetails from '@/app/shared/components/dialogs/campaign-details.vue';
import DialogRefundHistory from '@/app/shared/components/dialogs/refund-history.vue';
import DialogBankslipResend from '@/app/shared/components/dialogs/bankslip-resend.vue';
import DialogBrcodeResend from '@/app/shared/components/dialogs/brcode-resend.vue';
import DialogPayment from '@/app/shared/components/dialogs/payment.vue';

@Component({
  components: {
    DialogCampaignDetails,
    DialogRefundHistory,
    DialogPayment,
    DialogBankslipResend,
    DialogBrcodeResend,
  },
})
export default class DataTableCampaignsComponent extends Vue {
  @Prop(Array) readonly campaigns!: CampaignModel[];

  public campaignTemp?: CampaignModel;
  public headers: DataTableHeader[] = [];
  public loading = false;
  public dialog = false;
  private dialogRefundHistory = false;
  private dialogPayment = false;
  private dialogBankSlipResend = false;
  private dialogBrcodeResend = false;

  private get refs() {
    return refsService;
  }

  public openCampaignDetail(item: CampaignModel) {
    this.campaignTemp = item;
    this.dialog = true;
  }

  private created(): void {
    this.headers = [
      {
        text: this.$t('headers.start_campaign_date').toString(),
        value: 'StartDate',
      },
      {
        text: this.$t('headers.campaign_name').toString(),
        value: 'Name',
      },
      {
        text: this.$t('headers.billing_method').toString(),
        value: 'PaymentMethod',
      },
      {
        text: this.$t('headers.number_installment').toString(),
        value: 'FilterInstallmentNumber',
      },
      {
        text: this.$t('headers.contract_status').toString(),
        value: 'ContractStatus',
      },

      {
        text: this.$t('headers.attempts_number').toString(),
        value: 'FilterAttemptNumber',
      },
      {
        text: this.$t('headers.rule_deadline').toString(),
        value: 'EndDate',
      },
      {
        text: this.$t('headers.campaign_status').toString(),
        value: 'Active',
      },
      { text: '', value: 'Actions', sortable: false, align: 'end' },
    ];
  }
}
